module.exports = __webpack_public_path__ + "img/manet_1.d3a071e9.jpg";